import { defineComponent } from 'vue'

export type CallFun = () => void
export interface RenderCallbackObj {
  /**
   * 自定义mounted回调
   */ mountedCallFun?: CallFun
  /**
   * 自定义updated回调
   */
  updatedCallFun?: CallFun
  /**
   * 自定义unmounted回调
   */
  unmountedCallFun?: CallFun
}
const factory = ({ mountedCallFun, updatedCallFun, unmountedCallFun }: RenderCallbackObj) => {
  return defineComponent({
    props: {
      vnode: null
    },
    mounted () {
      // 这个this.$el就代表当前vnode的dom对象
      mountedCallFun && mountedCallFun()
    },
    updated () {
      updatedCallFun && updatedCallFun()
    },
    unmounted () {
      unmountedCallFun && unmountedCallFun()
    },
    render (props:any) {
      return props.vnode
    }
  })
}

export default factory
